module.exports = __webpack_public_path__ + "img/portfolio2.b56d9632.png";